import { render, staticRenderFns } from "./BookingTalentRecommendations.vue?vue&type=template&id=5f0defb7"
import script from "./BookingTalentRecommendations.vue?vue&type=script&lang=js"
export * from "./BookingTalentRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports